(function () {
  if (window.__cmPolish) return;
  window.__cmPolish = true;
  var mobile = window.matchMedia('(max-width:989px)');
  var reduced = window.matchMedia('(prefers-reduced-motion:reduce)');
  function sliders() {
    document.querySelectorAll('[data-cm-hero-slider]').forEach(function (root) {
      if (root.dataset.sliderBound) return;
      root.dataset.sliderBound = 'true';
      var slides = Array.from(root.querySelectorAll('[data-cm-slide]'));
      var dots = Array.from(root.querySelectorAll('[data-cm-slide-index]'));
      var active = 0;
      function show(index) {
        if (!slides.length) return;
        active = (index + slides.length) % slides.length;
        slides.forEach(function (slide, i) { slide.hidden = i !== active; });
        dots.forEach(function (dot) { dot.setAttribute('aria-pressed', String(Number(dot.dataset.cmSlideIndex) === active)); });
        document.dispatchEvent(new CustomEvent('cm:hero-slide'));
      }
      root.addEventListener('click', function (event) {
        var step = event.target.closest('[data-cm-slide-step]');
        var dot = event.target.closest('[data-cm-slide-index]');
        if (step) show(active + Number(step.dataset.cmSlideStep));
        if (dot) show(Number(dot.dataset.cmSlideIndex));
      });
      root.addEventListener('keydown', function (event) {
        if (!event.target.closest('.cm-hero-controls')) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          show(active + (event.key === 'ArrowRight' ? 1 : -1));
        }
      });
      document.addEventListener('shopify:block:select', function (event) {
        if (!root.isConnected || !event.detail) return;
        var index = slides.findIndex(function (slide) { return slide.dataset.cmBlockId === event.detail.blockId; });
        if (index >= 0) show(index);
      });
      show(0);
    });
  }
  function videos() {
    document.querySelectorAll('[data-cm-video-hero]').forEach(function (section) {
      var video = section.querySelector('video');
      var toggle = section.querySelector('[data-cm-video-toggle]');
      if (!video || video.dataset.bound) return;
      video.dataset.bound = 'true';
      var pausedByUser = false;
      function state() {
        if (!toggle) return;
        var playing = !video.paused;
        toggle.hidden = !video.currentSrc;
        toggle.setAttribute('aria-label', playing ? toggle.dataset.pauseLabel : toggle.dataset.playLabel);
        toggle.querySelector('span').textContent = playing ? 'Ⅱ' : '▶';
      }
      function play() {
        if (!section.hidden && !pausedByUser && !reduced.matches && !document.hidden) video.play().catch(function () { state(); });
      }
      function sources(value) {
        try { return (JSON.parse(value || '[]') || []).filter(function (s) { return s.mime_type === 'video/mp4' || s.mimeType === 'video/mp4' || s.format === 'mp4'; }); }
        catch (error) { return []; }
      }
      function select() {
        if (section.hidden) return;
        var list = sources(mobile.matches ? video.dataset.mobileSources : video.dataset.desktopSources);
        if (!list.length) list = sources(mobile.matches ? video.dataset.desktopSources : video.dataset.mobileSources);
        if (!list.length) return;
        list.sort(function (a, b) { return a.width - b.width; });
        var target = mobile.matches ? Math.min(window.innerWidth * (window.devicePixelRatio || 1), 780) : Math.min(window.innerWidth, 1920);
        var chosen = list.find(function (s) { return s.width >= target; }) || list[list.length - 1];
        if (video.getAttribute('src') === chosen.url) return;
        section.classList.remove('is-ready');
        video.pause();
        var poster = mobile.matches ? video.dataset.mobilePoster : video.dataset.desktopPoster;
        if (poster) video.poster = poster;
        video.muted = true;
        video.src = chosen.url;
        video.load();
        play();
      }
      video.addEventListener('loadeddata', function () { section.classList.add('is-ready'); state(); });
      video.addEventListener('play', state);
      video.addEventListener('pause', state);
      video.addEventListener('error', function () { section.classList.remove('is-ready'); if (toggle) toggle.hidden = true; });
      if (toggle) toggle.addEventListener('click', function () {
        pausedByUser = !video.paused;
        if (video.paused) video.play().catch(state); else video.pause();
      });
      mobile.addEventListener('change', function () { if (section.isConnected) select(); });
      reduced.addEventListener('change', function () { if (reduced.matches) video.pause(); else play(); });
      document.addEventListener('visibilitychange', function () { if (document.hidden) video.pause(); else play(); });
      document.addEventListener('cm:hero-slide', function () {
        if (!section.isConnected) return;
        if (section.hidden) video.pause(); else { select(); play(); }
      });
      select();
    });
  }
  document.addEventListener('click', function (event) {
    var burger = event.target.closest('[data-cm-burger]');
    if (burger) {
      var header = burger.closest('.cm-hd');
      var open = header.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', String(open));
    }
    var question = event.target.closest('.cm-faq__q');
    if (question) {
      var item = question.parentElement;
      var faq = question.closest('[data-cm-faq]');
      var open = !item.classList.contains('is-open');
      faq.querySelectorAll('.cm-faq__i').forEach(function (entry) {
        var active = entry === item && open;
        entry.classList.toggle('is-open', active);
        entry.querySelector('.cm-faq__q').setAttribute('aria-expanded', String(active));
      });
    }
  });
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.cm-hd.is-open').forEach(function (header) {
      header.classList.remove('is-open');
      var burger = header.querySelector('[data-cm-burger]');
      burger.setAttribute('aria-expanded', 'false');
      burger.focus();
    });
  });
  function init() { sliders(); videos(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
